import AppImage from '@/components/ui/AppImage';

interface HeroSectionProps {
  className?: string;
}

const HeroSection = ({ className = '' }: HeroSectionProps) => {
  return (
    <section className={`relative h-[500px] lg:h-[600px] overflow-hidden ${className}`}>
      <div className="absolute inset-0">
        <AppImage
          src="https://images.unsplash.com/photo-1732360489182-4ecc94d72b7b"
          alt="Aerial view of Bangalore cityscape with modern skyscrapers and green spaces during golden hour"
          className="w-full h-full object-cover"
          priority />

        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-transparent"></div>
      </div>
      
      <div className="relative h-full max-w-7xl mx-auto px-4 lg:px-8 flex items-center">
        <div className="max-w-2xl">
          <h1 className="font-display text-4xl lg:text-6xl font-bold text-white mb-6">
            Your Complete Guide to Bangalore Living
          </h1>
          <p className="text-lg lg:text-xl text-white/90 mb-8">
            Discover everything you need to know about the Bannerghatta Road area, from corporate hubs to cultural experiences. Your journey to premium serviced living starts here.
          </p>
          <div className="flex flex-wrap gap-4">
            <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20">
              <p className="text-sm text-white/80">Distance to IIM Bangalore</p>
              <p className="text-2xl font-bold text-white">160 m</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20">
              <p className="text-sm text-white/80">Corporate Hubs Nearby</p>
              <p className="text-2xl font-bold text-white">15+</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm px-6 py-3 rounded-lg border border-white/20">
              <p className="text-sm text-white/80">Dining Options</p>
              <p className="text-2xl font-bold text-white">30+</p>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;